export default "__VITE_ASSET__DOjfjN69__"